export default __webpack_public_path__ + "static/media/GalleryFirstAllFullSize.7f020032.png";